import gql from 'graphql-tag';

const GET_CARDS_QUERY = gql`
  query getCards {
    getCards {
        message,
        default_source,
        data {
          id,
          brand,
          exp_month,
          exp_year,
          name,
          last4,
          country,
          address_zip,
          address_country,
        }
    }
  }`;

const GET_TOTAL_PAYMENT_QUERY = gql`
  query income {
    income {
      message,
      data {
        sessionFee,
        expertFee,
        commission,
        subscriptionFee,
        addonFee,
      }
    }
}`;

const GET_PAYMENT_QUERY = gql`
  query incomeLogs($limit: Int, $page: Int,
    $sort: String, $sortBy: Int, $type: String, $title: String, $eventType: String, $category: String, $domain: String,
    $filter: String, $columnHeaders:[String], $columnKeys: [String], $isGenerateReport: Boolean, $reportTitle: String) {
      incomeLogs(limit: $limit, page: $page,
      sort:$sort, sortBy: $sortBy, type: $type, title: $title, eventType: $eventType, category: $category, domain: $domain, 
      filter: $filter, columnHeaders: $columnHeaders, columnKeys: $columnKeys,
      isGenerateReport: $isGenerateReport, reportTitle: $reportTitle) {
      message,
      count,
      url,
      reportTitle,
      data {
        openfieldCommissionAmt,
        expertFee,
        sessionFee,
        bidData {
          _id,
          endedAt,
          participants {
            email
          },
          proposedDate
        }
        goalData {
          title,
          _id,
          endedAt
        },
        senderData {
          organizationName,
          firstName,
          lastName,
          role
          email
        }
        receiverData {
          firstName
          lastName
          hourlyRate {
            current
          }
        },
        commission
        amount
        invoice
        subscriptionId
        quantity
        createdAt
        addOnAmount,
        type,
        status
      }
    }
  }`;

const GET_TAX_RATE = gql`
  query getTaxRate($postalCode: String!, $countryCode: String!) {
    getTaxRate(postalCode: $postalCode, countryCode: $countryCode) {
      message,
      taxRate
    }
}`;

export { GET_CARDS_QUERY, GET_TOTAL_PAYMENT_QUERY, GET_PAYMENT_QUERY, GET_TAX_RATE };
